import { render, staticRenderFns } from "./BFormAttachment.vue?vue&type=template&id=27b1e170&scoped=true&"
import script from "./BFormAttachment.vue?vue&type=script&lang=js&"
export * from "./BFormAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1e170",
  null
  
)

export default component.exports